export const SAVE_DAILY_MONITORING_REPORT = "SAVE_DAILY_MONITORING_REPORT"